import { Wrench } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { useSpace } from "@/context/SpaceContext";
import { setAtelier, useAtelier } from "@/lib/atelierChoice";

// Creator / admin only (never rendered in developer spaces): this APK goes to the atelier, no auto-publish.
export const AtelierPick = ({ testId = "upload-atelier" }) => {
  const { t } = useI18n();
  const { isDev } = useSpace();
  const on = useAtelier();
  if (isDev) return null;
  return (
    <label className="flex min-w-0 cursor-pointer items-start gap-2 rounded-2xl border border-[rgba(245,197,66,0.18)] bg-black/30 p-3 text-sm font-semibold text-neutral-100" data-testid={testId}>
      <input type="checkbox" className="mt-1 h-4 w-4 shrink-0 accent-[var(--gold)]" checked={on} onChange={(e) => setAtelier(e.target.checked)} data-testid={`${testId}-checkbox`} />
      <span className="min-w-0 break-words">
        <Wrench className="me-1 inline h-4 w-4 text-[var(--gold)]" />{t("atelier.send")}
        <span className="mt-1 block text-[0.7rem] font-normal text-neutral-500">{t("atelier.sendHint")}</span>
      </span>
    </label>
  );
};
